import { colors } from '@mosanic/styles';
import { removeNotification } from '@redux/notification/action';
import { getNotificationsSelector } from '@redux/notification/reducer';
import { isString } from '@util/Text';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Notifications = () => {
    // const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const dispatch = useDispatch();
    const notifications = useSelector(getNotificationsSelector);
    const [displayed, setDisplayed] = useState([])

    // const removeDisplayed = useCallback((id) => {
    //     setDisplayed([...displayed.filter(key => key != id)])
    // }, [displayed])

    // const dismiss = useCallback((key) => {
    //     dispatch(dismissNotification({notificationId: key, feature: 'snackbar'}));
    //     removeDisplayed(key);
    // },[dispatch, removeDisplayed])
   



    useEffect(() => {
        if(!notifications || notifications?.length === 0) return undefined;
        
        notifications.forEach(notification => {
            if(!isString(notification?.message)) return;

            const type = notification?.variant ? notification.variant : 'warning';

            toast[type](notification?.message, {
                position: notification?.position,
                autoClose: notification?.persist ? false : notification?.duration,
                // autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            dispatch(removeNotification({notificationId: notification?._id, feature: '[auto]'}))
        });
    
        return () => {}
    }, [dispatch, notifications])
    
    return (
    <> 
    <style>
        {`
        :root{
            --toastify-color-info: ${colors.util.primary.base};
            --toastify-color-success: ${colors.util.bright.green};
            --toastify-color-warning: ${colors.util.bright.orange};
            --toastify-color-error: ${colors.util.bright.red};
        }`}
    </style>
    <ToastContainer 
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
    />

    </>
    )
};
export default Notifications;